<template>
  <div id="email-body" class="email contatto" style="position:absolute;top:0;left:0;"  >

    <table cellmargin="0" cellspacing="0" width="800" align="center" border="0" style="border:none;"><tr><td>


      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td width="100%">
          <a href="https://www.innsin.it" style="margin:10px 0 0 0;"><img src="https://www.innsin.it/images/innsin-sin.jpg" style="width:380px;border:none;" /></a>
          <br /><br />
        </td>
      </tr></table>

<br />
      &#160;
<br />



      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td>
           
          Gentile {{contatto.nome }} {{contatto.cognome }}
          <br /><br />
          la presente per confermare la ricezione della Sua richiesta di adesione al progetto INNSIN, in qualità di Referente del Network per il Suo Centro.
          <br /><br />
          Le Sue credenziali per accedere al sito <a href="https://www.innsin.it/network">https://www.innsin.it</a> sono le seguenti:
        </td>    
      </tr></table>

      <table cellmargin="8" cellspacing="8" width="780" align="center"><tr> 
        <tr>
          <td width="40%">
            <div style="text-align:center;">EMAIL</div>
          </td>
          <td width="60%">
            {{contatto.email}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            <div style="text-align:center;">PASSWORD</div>
          </td>
          <td width="60%">
            {{contatto.password}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            &#160;
          </td>
          <td width="60%">
            &#160;
          </td>    
        </tr>
      </table>



      <table cellmargin="8" cellspacing="8" width="720" align="center"><tr> 
         <tr>
            <td>
            Prima di poter partecipare attivamente al Network INNSIN ed imputare le schede dei pazienti, è necessario compilare, firmare digitalmente e ricaricare sul sito i documenti, disponibili su <a href="https://www.innsin.it/network">https://www.innsin.it</a> ed attendere dalla Segreteria INNSIN accettazione della richiesta.
            <br /><br />
            Cordiali saluti
            <br />
            La segreteria INNSIN
            </td>
         </tr>
      </table>





  </td ></tr></table>
</div>
</template>

<script>
export default {
   props: ['contatto'],
   beforeDestroy: function(){
     console.log("VM DISTRUTTA")
   }
}
</script>
